module.exports = __webpack_public_path__ + "../assets/img/827e85f9e392604194b1146ca08597c1.svg";